export default __webpack_public_path__ + "static/media/pic1.db3bd44d.jpg";